var Yacht = {
		 source:null,
	     mapButton : null
};﻿

var YachtResult = {
	map : false,
	isYachtListNotEmpty : false,
	centerLatLon : null
};